<template>
  <div
    class="services-area-three si-without-border-radius bg-secondary ptb-100"
  >
    <div class="container">
      <div
        class="section-title text-center m-auto"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">خدماتنا المميزة</span>
        <h2 class="text-white">اكتشف باقات الترفيه والمزايا التي نقدمها</h2>
      </div>

      <div class="row justify-content-center">
        <div
          v-for="(service, index) in services"
          :key="index"
          class="col-lg-4 col-sm-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="100 * (index + 1)"
        >
          <div class="position-relative z-1 shape-wrap">
            <div class="services-single-item-three hover-style1">
              <div class="hover-style2">
                <i :class="service.icon" class="icon"></i>
                <h3>
                  <a href="https://wa.me/447429916178" target="_blank">
                    {{ service.title }}
                  </a>
                </h3>
                <p>{{ service.description }}</p>
                <a
                  href="https://wa.me/447429916178"
                  target="_blank"
                  class="read-more style-two text-grey-teal"
                >
                  اشترك الآن
                  <i class="ti ti-arrow-right"></i>
                </a>
              </div>
            </div>
            <img
              src="@/assets/images/services-shape.png"
              class="services-shape d-none d-xl-block"
              alt="services-shape"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "OurServices",
  setup() {
    const services = ref([
      {
        title: "البث الرياضي المباشر",
        description: "تغطية كاملة وشاملة لكافة البطولات والدوريات العالمية والعربية بجودة VIP وبدون أي تقطيع.",
        icon: "flaticon-global-network",
      },
      {
        title: "مكتبة الأفلام المحدثة",
        description: "آلاف الأفلام العربية والأجنبية المترجمة بدقة عالية، مع تحديثات يومية لإضافة أحدث الإصدارات.",
        icon: "flaticon-box",
      },
      {
        title: "المسلسلات والبرامج",
        description: "مجموعات كاملة وحصرية من أحدث المسلسلات والبرامج التلفزيونية والمنصات الشهيرة في مكان واحد.",
        icon: "flaticon-global-network",
      },
      {
        title: "سيرفرات فائقة السرعة",
        description: "نعتمد على بنية تحتية قوية تضمن ثبات البث بدقة 4K حتى أثناء الضغط العالي والمباريات الجماهيرية.",
        icon: "flaticon-global-network",
      },
      {
        title: "توافق كامل مع الأجهزة",
        description: "الاشتراك يعمل بكفاءة على الشاشات الذكية، أجهزة التي في بوكس، الهواتف الذكية، وأجهزة الحواسيب.",
        icon: "flaticon-phone-call-2",
      },
      {
        title: "دعم فني متواصل 24/7",
        description: "فريق دعم فني متخصص متواجد على مدار الساعة لمساعدتك في تفعيل الاشتراك وإعداد التطبيقات فوراً.",
        icon: "flaticon-smart-home",
      },
    ]);

    return { services };
  },
});
</script>